import { debounce } from '@bettermode/common/debounce'
import { throttle } from '@bettermode/common/throttle'

import {
  IsTypingEvent,
  StoppedTypingRequest,
} from '../../Providers/Socket/constants.js'
import { SocketContextType } from '../../Providers/Socket/SocketProvider.js'
import {
  TIsTypingClientPayload,
  TStoppedTypingClientPayload,
} from '../../Providers/Socket/types.js'

const TYPING_THROTTLE_TIME = 2000
const STOPPED_TYPING_DEBOUNCE_TIME = 3000

const throttledEmitIsTyping = throttle(
  (chatId: string, socket: SocketContextType['socket']) => {
    const payload: TIsTypingClientPayload = {
      chatId,
    }
    socket.volatile.emit(IsTypingEvent, payload)
  },
  TYPING_THROTTLE_TIME,
  { leading: true, trailing: false },
)

export const emitStoppedTyping = (
  chatId: string,
  socket: SocketContextType['socket'],
) => {
  const payload: TStoppedTypingClientPayload = {
    chatId,
  }
  socket.volatile.emit(StoppedTypingRequest, payload)
}

const debouncedEmitStoppedTyping = debounce(
  emitStoppedTyping,
  STOPPED_TYPING_DEBOUNCE_TIME,
  {
    start: false,
  },
)

export const emitIsTyping = (
  chatId: string,
  socket: SocketContextType['socket'],
) => {
  throttledEmitIsTyping(chatId, socket)
  debouncedEmitStoppedTyping(chatId, socket)
}
